export default "__VITE_ASSET__DcmxGrmA__"